$(document).ready(function () {
    $(document).on('click', 'li.parent > a', function() {
        $(this).next().slideToggle();
        $(this).toggleClass('active');
    })
});